import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Menu } from '@luxe/components';
import { BarsOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'emotion-theming';
import theme from '../../../theme';
import { getAccountOrg } from 'account/modules/accountOrg';

const UserProfileMenu = ({ location, accountOrg, getAccountOrg }) => {
  let key = 'profile';
  const subMenus = ['profile-head'];

  let pathname = location.pathname.split('/');
  key = pathname[2];

  const menuItems = [
    {
      key: 'profile-head',
      label: 'Profile',
      icon: <BarsOutlined />,
      className: 'crappola',
      children: [
        {
          key: 'profile',
          label: (
            <Link to="/users/profile/">
              <span>General</span>
            </Link>
          ),
        },
        {
          key: 'network',
          label: (
            <Link to="/users/network/">
              <span>Network Settings</span>
            </Link>
          ),
        },
        {
          key: 'notifications',
          label: (
            <Link to="/users/notifications/">
              <span>Notifications</span>
            </Link>
          ),
        },
      ],
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Menu items={menuItems} mode="inline" selectedKeys={[key]} defaultOpenKeys={subMenus} />
    </ThemeProvider>
  );
};

function mapStateToProps({ accountOrg, router }) {
  return {
    accountOrg,
    location: router.location,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAccountOrg: getAccountOrg,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileMenu);
